/**
 * @generated SignedSource<<357b5967c3443594bb49fccf0365a385>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveSupplierAmountOverrideInput = {
  id: string;
};
export type RemoveSupplierAmountOverrideDialogMutation$variables = {
  input: RemoveSupplierAmountOverrideInput;
};
export type RemoveSupplierAmountOverrideDialogMutation$data = {
  readonly removeSupplierAmountOverride: {
    readonly id: string;
  };
};
export type RemoveSupplierAmountOverrideDialogMutation = {
  response: RemoveSupplierAmountOverrideDialogMutation$data;
  variables: RemoveSupplierAmountOverrideDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IdPayload",
    "kind": "LinkedField",
    "name": "removeSupplierAmountOverride",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveSupplierAmountOverrideDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveSupplierAmountOverrideDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "de750f00311aa6c1da755bcb345a6f70",
    "id": null,
    "metadata": {},
    "name": "RemoveSupplierAmountOverrideDialogMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveSupplierAmountOverrideDialogMutation(\n  $input: RemoveSupplierAmountOverrideInput!\n) {\n  removeSupplierAmountOverride(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "15a5fa8968ae9ed5bfcd77dc4681e10e";

export default node;
